import { createBrowserHistory } from "history";

const history = createBrowserHistory({ window });

// this is a temporary abstraction that should implment an api that looks like react router history.
export const useHistory = () => history;
